import { render, staticRenderFns } from "./client_space_app_event.vue?vue&type=template&id=a2409b8e&scoped=true"
import script from "./client_space_app_event.vue?vue&type=script&lang=js"
export * from "./client_space_app_event.vue?vue&type=script&lang=js"
import style0 from "./client_space_app_event.vue?vue&type=style&index=0&id=a2409b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2409b8e",
  null
  
)

export default component.exports